import { createAction, props } from '@ngrx/store';
import { JobAndUnitRequirementsDto } from 'src/app/shared/models/job-unit-requirements.model';
import { AvailableSkillsDto } from 'src/app/shared/components/job-qualifications/models/available-skills.model';
import { AvailableCertsDto } from 'src/app/shared/components/job-qualifications/models/available-certs.model';
import { JobQualificationChanges } from 'src/app/shared/components/job-qualifications/models/job-qualifications-changes.model';
import { JobAlternativeCertificationDto } from 'src/app/shared/components/job-qualifications/models/certification-with-related.model';

export const loadQualifications = createAction(
    '[JOB QUALIFICATIONS] Load Job Qualifications',
    props<{ jobId: number }>()
);
export const loadQualificationsSuccess = createAction(
    '[JOB QUALIFICATIONS] Load Job Qualifications Success',
    props<{ qualifications: JobAndUnitRequirementsDto }>()
);
export const loadQualificationsFailure = createAction(
    '[JOB QUALIFICATIONS] Load Job Qualifications Failure',
    props<{ error: unknown }>()
);
export const loadQualificationChanges = createAction(
    '[JOB QUALIFICATIONS] Load Job Qualification Changes',
    props<{ jobId: number }>()
);
export const loadQualificationChangesSuccess = createAction(
    '[JOB QUALIFICATIONS] Load Job Qualification Changes Success',
    props<{ changes: JobQualificationChanges }>()
);
export const loadQualificationChangesFailure = createAction(
    '[JOB QUALIFICATIONS] Load Job Qualification Changes Failure',
    props<{ error: unknown }>()
);
export const resetQualificationChanges = createAction('[JOB QUALIFICATIONS] Reset Job Qualification Changes');
export const loadAvailableSkills = createAction(
    '[JOB QUALIFICATIONS] Load Available Skills',
    props<{ professionId: number; expertiseId: number; clinicalTrackId?: number }>()
);
export const loadAvailableSkillsSuccess = createAction(
    '[JOB QUALIFICATIONS] Load Available Skills Success',
    props<{ skills: AvailableSkillsDto[] }>()
);
export const loadAvailableSkillsFailure = createAction(
    '[JOB QUALIFICATIONS] Load Available Skills Failure',
    props<{ error: unknown }>()
);
export const loadAvailableCerts = createAction(
    '[JOB QUALIFICATIONS] Load Available Certs',
    props<{ professionId: number; expertiseId: number; clinicalTrackId?: number }>()
);
export const loadAvailableCertsSuccess = createAction(
    '[JOB QUALIFICATIONS] Load Available Certs Success',
    props<{ certs: AvailableCertsDto[] }>()
);
export const loadAvailableCertsFailure = createAction(
    '[JOB QUALIFICATIONS] Load Available Certs Failure',
    props<{ error: unknown }>()
);

export const getRequirementsFromUD = createAction('[JOB QUALIFICATIONS] Reset To UD', props<{ jobId: number }>());
export const getRequirementsFromUDSuccess = createAction(
    '[JOB QUALIFICATIONS] Reset To UD Success',
    props<{ qualifications: JobAndUnitRequirementsDto }>()
);
export const getRequirementsFromUDFailure = createAction(
    '[JOB QUALIFICATIONS] Reset To UD Failure',
    props<{ error: unknown }>()
);

export const updateJobLevelAlternatives = createAction(
    '[JOB QUALIFICATIONS] Update Job Level Alternatives',
    props<{ alternatives: JobAlternativeCertificationDto[] }>()
);
